<script>
import { layoutMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { reportsMethods, reportsComputed, exportMethods,eventListMethods,eventsComputed,eloadRewardsComputed,eloadRewardsMethods } from "@/state/helpers"
// import { stat } from "fs";
import Swal from 'sweetalert2';
import Multiselect from "vue-multiselect";
import shortid from "shortid";
import * as XLSX from 'xlsx';
import _ from "lodash";
import dedupe from "dedupe";

/**
 * E-Load list component
 */
export default {
  page: {
    title: "E-Load Add Rewards"
  },
  data() {
    return {
      searchValue: {
        searchField: null,
        search: "",
        dateRange: null,
        sort: 'id',
        orderDesc: true,
        page: 1,
        rows: 10,
        selectedUsers: []
      },
      searchList: [
        { text: "Search All", value: null },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Contact Number", value: "mobile_number" }
      ],
      tblFields: [
        {
          key: 'account_freeze',
          label:'Account Status',
          sortable: false
        },
        {
          key: 'business',
          label:'Store Name',
          sortable: false
        },
        {
          key: 'name',
          label:'Customer Name',
          sortable: false
        },
        {
          key: 'mobile_number',
          sortable: false
        },
        {
          key: 'email_address',
          sortable: false
        },
        {
          key: 'action',
          sortable: false
        },
      ],
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      eloadRewardsForm: {
        receiver: [],
        amount:null,
        type:null,
        name:null,
        event_date:null,
        note:null,
        file:null,
        s3_url:null,
        saveType:null
      },
      massUploadFile: null,
      massUploadData: null,
      formExitChecker: {
        receiver: [],
        amount:null,
        type:null,
        name:null,
        event_date:null,
        note:null,
        file:null,
        s3_url:null,
        saveType:null
      },
      typeOptions:[
        {"value":"c","name":"Compensation for irate cx"},
        {"value":"r","name":"Reimbursement"},
        {"value":"p","name":"Promo"},
        {"value":"g","name":"Giveaway"},
        {"value":"s","name":"Sales"},
      ],
      isLoading: false,
      config: {
        enableTime: true,
        dateFormat: "m/d/Y h:i K",
        maxDate: new Date()
      },
      submitted: false,
      eloadRewardFile: {
        filename: null,
        type: null,
        base64: null
      },
      createModal: false,
      addWinner: false,
      addWinnerAmount: null,
      addWinnerTblFields: [
        {
          key: 'action',
          sortable: false
        },
        {
          key: 'business',
          label:'Store Name',
          sortable: false
        },
        {
          key: 'name',
          label:'Customer Name',
          sortable: false
        },
        {
          key: 'mobile_number',
          sortable: false
        },
        {
          key: 'email_address',
          sortable: false
        },
        {
          key: 'amount',
          sortable: false
        },
      ],
      TotalWinnerAmount: 0,
      displayWinnerPagination:{rows:10,page:1},
      displayWinnerTbl:[],
      maxSizeInBytes: 300000
    };
  },
  validations: {
    eloadRewardsForm: {
      receiver: {required},
      type:{required},
      name:{required},
      event_date:{required},
      file:{required},
      // note:{required}
    },
  },
  components: {
    flatPickr,
    Multiselect,
  },
  computed: {
    ...reportsComputed,
    ...eventsComputed,
    ...eloadRewardsComputed,
  },
  mounted() {
    // this.getUserList();
    this.changeTitle({title: 'Eload Send Reward'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Report', to: { name: 'Report'}},
        { text: 'Eload Rewards', to: { name: 'Eload Rewards'}},
        { text: 'Eload Add Rewards', to: { name: 'Eload Add Rewards'}},
      ]
    });
    if(this.$route.params.id > 0){
      this.getEventInfo(this.$route.params.id);
    }
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...eventListMethods,
    ...eloadRewardsMethods,
    async getEventInfo(id){
      await this.actionEloadReward({
          action: "eload-rewards-info",
          body: {"event_id":id}
      })
      .then((res) => {
        console.log(res);
        res.message.file = res.message.supporting_document
        res.message.s3_url = res.message.supporting_document
        this.eloadRewardsForm = {...res.message};
        this.formExitChecker = {...res.message};
        this.eloadRewardsForm.event_date = new Date(res.message["event_date"]);
        this.winnerTblPaginator();
        this.recompute();
        // this.onFileChange(res.message["documentSignUrl"]);
      }).catch((e)=>{
        console.log("error while getting reward info",e);
      });
    },
    async getUserList(state=''){
      // if(state == 'reset'){
      //   this.searchValue.page = 1;
      // }
      this.isLoading = true
      console.log(">> query:", state);
      // this.searchValue.search = this.searchValue.search.length > 0 ? this.searchValue.search : state;
      this.searchValue.selectedUsers = [];
      // console.log(">> searchvalue1",this.searchValue);
      // console.log(">> eload receiver",this.eloadRewards);
      for(let x of this.eloadRewardsForm.receiver){
        this.searchValue.selectedUsers.push(x.id)
      }
      // console.log(">> searchvalue2",this.searchValue);
      var self = this;
      await this.getAllUsers(this.searchValue)
      .then(function(res){
        console.log("check:",res);
        self.isLoading = false;
      })
      .catch(function(e){
          Swal.fire("Loading Failed!", `${e}`, "error");
      });
    },
    isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
    },
    onDisplayChange(){
        console.log(this.attendeeTotalRowsModal,this.searchValue.rows,this.userList.length,(this.userList.length < this.attendeeTotalRowsModal && this.userList.length != this.searchValue.rows));
        if(
          (this.userList.length < this.attendeeTotalRowsModal && this.userList.length != this.searchValue.rows) || // condition for incrementing display per page
          (this.userList.length == this.attendeeTotalRowsModal && this.searchValue.rows < this.userList.length) // condition for decreasing display per page
          ){
          this.searchValue.page=1;
          this.getUserList()
        }
        return;
    },
    testTopupReward(){
      var params = {
          "sub": "",//"07a7066f-e602-4c6e-a141-109844d240c4",
          "margin": "1"
      }
      this.testReward(params)
      .then(function(res){
        console.log("check:",res);
      })
      .catch(function(e){
        console.log("check:",e);
      });
    },
    customName ({ name, mobile_number, email, cognito_sub,business }) {
      if(name == null && mobile_number == null && email == null){
        return cognito_sub == null ? business + " (No Wallet ID)" : cognito_sub
      }else{
        var r_message = '';
        r_message +=  (name == null ? "":(r_message.length > 0? " - " : "" ) + name.charAt(0).toUpperCase() + name.slice(1));
        r_message +=  (business == null ? "":(r_message.length > 0? " - " : "" ) + business.charAt(0).toUpperCase() + business.slice(1));
        r_message +=  (cognito_sub == null ? "":(r_message.length > 0? " - " : "" ) + cognito_sub);
        r_message +=  (mobile_number == null ? "":(r_message.length > 0? " - " : "" ) + mobile_number);
        r_message +=  (email == null ? "":(r_message.length > 0? " - " : "" ) + email);
        r_message +=  (cognito_sub == null ? " (No Wallet ID) ":"");
        return r_message
      }
    },
    isNumber ($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
      }else{
          // console.log(">>>>>",this.eloadRewardsForm.amount);
      }
    },
    clearAll () {
      this.eloadRewardsForm.receiver = []
    },
    async handleSubmit() {      
      // alert("Form submit");
      this.submitted = true
      this.$v.$touch();

      // console.log(":: handleSubmit ::", JSON.stringify(this.$v.eloadRewardsForm))
      if (!this.$v.eloadRewardsForm.$invalid){
        if(this.eloadRewardsForm.saveType != "dr"){
          Swal.fire({
            title: "Are you sure?",
            text: `You will no longer be able to edit this request.`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.value) {
              this.uploadEloadRewardSupportingDocument();
            }
          });
        }else{
            this.uploadEloadRewardSupportingDocument();
        }
        // alert("clean");
        // console.log(">> data:", JSON.stringify(this.eloadRewardsForm))
      }
    },
    uploadEloadRewardSupportingDocument(){
      if(this.eloadRewardFile.base64){
        var eloadRewardFile = { ...this.eloadRewardFile };
        this.uploadSupportingDocument(eloadRewardFile)
          .then((imageKey) => {
            this.eloadRewardsForm["s3_url"] = imageKey
            if((this.$route.params.id == 0 && this.$route.params.action == "new") || this.$route.params.action == "copy"){
              this.create();
            }else{
              this.update();
            }
          })
          .catch((err) => {
            Swal.fire("Upload Failed!",`${err}`, "error");
          });
      } else {
          if((this.$route.params.id == 0 && this.$route.params.action == "new") || this.$route.params.action == "copy"){
            this.create();
          }else{
            this.update();
          }
      }
    },
    create(){
        console.log(":: create ::", JSON.stringify(this.eloadRewardsForm));
        this.createReward(this.eloadRewardsForm)
        .then((data) => {
          console.log(data);
          this.submitted = false
          Swal.fire(
            "Create Successful!",
            `${this.eloadRewardsForm.name} has been created.`,
            "success"
          );
          this.formExitChecker = this.eloadRewardsForm
          console.log('Redirect Form', this.$route.query.redirectFrom)

          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Eload Rewards",
              query: { rewardId: data.rewardId }
            }
          );
          return;
        })
        .catch((error) => {
          console.log(error);
          // this.$alertify.error(error);
          Swal.fire(
            "Create Failed!",
            error,
            "warning"
          );
          this.submitted = false
          return;
        });
    },
    async update(){
      await this.actionEloadReward({
          action: "update",
          body: this.eloadRewardsForm
      })
      .then((res) => {
          console.log(":: update ::",res);
          this.submitted = false
          Swal.fire(
            "Update Successful!",
            `${this.eloadRewardsForm.name} has been updated.`,
            "success"
          );
          this.formExitChecker = this.eloadRewardsForm
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Eload Rewards",
              query: { rewardId: res.message.rewardId }
            }
          );
          return;
      }).catch((e)=>{
          console.log(":: update err ::",e);
          // this.$alertify.error(error);
          Swal.fire(
            "Update Failed!",
            e,
            "warning"
          );
          this.submitted = false
          return;
      });
    },
    compareStr(data, arr_similar){// case insensitive string comparison
      for(var i = 0; i < arr_similar.length; i++){
          var areEqual = data.toUpperCase() === arr_similar[i].toUpperCase();
            if(areEqual){
              return areEqual;
            }
        }
        return false;
    },
    processMassUploadFile(){
      // Run deduplication script
      var _this = this;
      var hasMissing = false;
      
      console.log('::MASS DATA::', this.massUploadData);      
      // Check if empty
      if(this.massUploadData.length == 0){
        Swal.fire({
          title: 'Invalid File!',
          text: "You added an empty file",
          icon: 'error',
          confirmButtonColor: '#E83092',
          confirmButtonText: 'Try Again',
        });
        return;
      } else {
        this.massUploadData.forEach(d => {
          if(!d.amount || !d.user_id){
            hasMissing = true;
            return;
          }
        });
        
        // Check if has missing data
        if(hasMissing){
          Swal.fire({
            title: 'Invalid File!',
            html: "You added an invalid data.<br/>The file has incomplete data.",
            icon: 'error',
            confirmButtonColor: '#E83092',
            confirmButtonText: 'Try Again',
          });
          return;
        }
      }

      this.fetchUserDetails(this.massUploadData)
        .then((data) => {
          console.log(data.message.userDetails);
          var original = data.message.userDetails;

          // Check for invalid user
          original.forEach(d => {
          if(!d.display){
              hasMissing = true;
              return;
            }
          });
          
          // Check if has missing data
          if(hasMissing){
            Swal.fire({
              title: 'Invalid File!',
              html: "You added an invalid data.<br/>The file has invalid user id.",
              icon: 'error',
              confirmButtonColor: '#E83092',
              confirmButtonText: 'Try Again',
            });
            return;
          }  

          const uniqueElements = new Set();
          var duplicates = [];
          original.map(o => JSON.stringify(o)).forEach(item => {
            if (uniqueElements.has(item)) {
              duplicates.push(item);
            } else {
              uniqueElements.add(item);
            }
          });
          
          duplicates = duplicates.map(d => JSON.parse(d));

          console.log('DUPLICATES:',duplicates);

          var duplicateContent = '';

          for(let d of duplicates){
            duplicateContent += `<div class="d-flex border-bottom p-2">
                  <div class="w-50">${d.user_id}</div>
                  <div class="w-50">${d.amount}</div>
                </div>`
          }

          if(duplicates.length > 0){
            Swal.fire({
              title: 'Invalid File!',
              text: "",
              icon: 'error',
              showCancelButton: true,
              html: `<div>
              <div class="mb-2">You added an invalid data.<br/>The file contained duplicate data.</div>
              <div class="text-primary fs-13 mb-4">Duplicate data will be removed once you select to proceed.</div>
              <div class="duplicate-container pt-1 pb-3 ps-3 pe-3 w-100">
                <div class="d-flex border-bottom p-2">
                  <div class="w-50 fw-bold">User ID</div>
                  <div class="w-50 fw-bold">Amount</div>
                </div>
                ${duplicateContent}
              </div>
              </div>`,
              reverseButtons: true,
              confirmButtonColor: '#E83092',
              cancelButtonColor: '#E83092',
              confirmButtonText: 'Proceed',
              cancelButtonText: 'Close'
            }).then((result) => {
                if (result.isConfirmed) {
                    var deduped = dedupe(_.cloneDeep(original));
                    deduped.forEach((d) => {
                      _this.addImportedWinner(d ,d.amount);
                    });

                    Swal.fire(
                      "Successfully Uploaded!",
                      `${this.massUploadFile.name} has been uploaded.`,
                      "success"
                    );

                    this.massUploadFile = null;
                    this.massUploadData = null;                    
                }else{
                    return;
                }
            })
          } else {
            data.message.userDetails.forEach((d) => {
              _this.addImportedWinner(d ,d.amount);
            });

            Swal.fire(
              "Successfully Uploaded!",
              `${this.massUploadFile.name} has been uploaded.`,
              "success"
            );

            this.massUploadFile = null;
            this.massUploadData = null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onMassUploadFileChange(event){
      var file = event.target.files ? event.target.files[0] : null;
      var _this = this;
      
      if (file) {
        const reader = new FileReader();
        console.log(event.target.files[0]);

        if(file.size > this.maxSizeInBytes){
          this.clearSupportingDocInput(file.size,"massWinnerInput");
          return;
        }

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          _this.massUploadData = data;
        }

        reader.readAsBinaryString(file);
      }
    },
    onFileChange(e){
      const reader = new FileReader();
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length || files[0].size > this.maxSizeInBytes){
        this.clearSupportingDocInput(files[0].size);
        this.eloadRewardFile = {
          filename: null,
          type: null,
          base64: null
        }
        return;
      }

      reader.onloadend = () => {
        var base64Data = reader.result;
        this.eloadRewardFile.type = base64Data.split(';')[0].split('/')[1];
          // console.log(">>> base64Data:",reader);
        // if(this.compareStr(this.eloadRewardFile.type,["jpeg","png","svg","jpg"])){
        //   this.eloadRewardFile.base64 = new Buffer.from(base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ''), 'base64');
        // }
        if(this.compareStr(this.eloadRewardFile.type,["csv","xlsx"])){
          this.eloadRewardFile.base64 = new Buffer.from(base64Data.replace(/^data:text\/[a-zA-Z+]+;base64,/, ''), 'base64');
        }
        if(this.compareStr(this.eloadRewardFile.type,["vnd.openxmlformats-officedocument.spreadsheetml.sheet"])){
          this.eloadRewardFile.base64 = new Buffer.from(base64Data.replace(/^data:application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,/, ''), 'base64');
        }
        // console.log("this.eloadRewardFile.base64",this.eloadRewardFile.base64);
        if(this.eloadRewardFile.type == 'svg+xml'){
          this.eloadRewardFile.type = 'svg';
        }
        this.eloadRewardFile.filename = `${shortid.generate()}.${this.eloadRewardFile.type}`;
        // console.log(this.eloadRewardFile);
        if(this.compareStr(this.eloadRewardFile.type,["csv","xlsx","vnd.openxmlformats-officedocument.spreadsheetml.sheet"]) === false){//"jpeg","png","svg","jpg",
            this.eloadRewardFile = {
              filename: null,
              type: null,
              base64: null
            }
            this.eloadRewardsForm.file = null;
          Swal.fire("Invalid supporting document!", `CSV or excel file is required`, "error");
        }
      }
      reader.readAsDataURL(files[0]);
    },
    openCreateModal(){
      this.createModal = true;
    },
    leaveform(next){
        console.log(this.eloadRewardsForm,this.formExitChecker);
        if(JSON.stringify(this.eloadRewardsForm) == JSON.stringify(this.formExitChecker)){
            next();
            return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
    onStorenameListener(query){
      if(query.length > 3){
        this.searchValue.search = query
        this.getUserList();
      }
    },
    onStorenameOpen(){
      if(this.userList.length == 0){
        this.searchValue.search = ""
        this.getUserList();
      }
    },
    async openAddWinnerModal(){
      await this.getUserList();
      this.addWinner = true;
    },
    addImportedWinner(winner, amount){
      console.log('Winner', winner);
      if(amount > 0 && amount <= 3000){
        this.eloadRewardsForm.receiver.push({...winner,amount:amount});
        this.TotalWinnerAmount += parseInt(amount);
        this.winnerTblPaginator();
      }
    },
    newWinner(winner){
      console.log('Winner', winner);
      if(this.addWinnerAmount > 0 && this.addWinnerAmount <= 3000){
        this.eloadRewardsForm.receiver.push({...winner,amount:this.addWinnerAmount});
        this.TotalWinnerAmount += parseInt(this.addWinnerAmount);
        this.winnerTblPaginator();
      }else{
        Swal.fire("Add Winner Failed!", `Invalid amount`, "error");
      }
    },
    removeWinner(winner){
      var index = this.eloadRewardsForm.receiver.findIndex(v => v.id === winner["id"]);
      this.TotalWinnerAmount -= parseInt(this.eloadRewardsForm.receiver[index]["amount"]);
      this.eloadRewardsForm.receiver.splice(index, 1);
      this.winnerTblPaginator();
    },
    isAddedInWinner(id){
      try {
        for(let x of this.eloadRewardsForm.receiver){
          if(Object.prototype.hasOwnProperty.call(x, "id")){
            if(x["id"] == id){
              return true;
            }
          }
        } 
        return false;
      } catch (error) {
        return false;
      }
    },
    winnerTblPaginator(){
      this.displayWinnerTbl = [];
      for(var i = ((this.displayWinnerPagination.page - 1)*this.displayWinnerPagination.rows); i < this.eloadRewardsForm.receiver.length; i++){
        if(this.displayWinnerTbl.length < this.displayWinnerPagination.rows){
          this.displayWinnerTbl.push(this.eloadRewardsForm.receiver[i]);
        }
      }
    },
    recompute(){
      this.TotalWinnerAmount = 0
      for(let x of this.eloadRewardsForm.receiver){
        this.TotalWinnerAmount += parseInt(x["amount"])
      }
    },
    getStatusClassColor(data) {
      return data == null || data == 0 ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0'; 
    },
    clearSupportingDocInput(size =0,ref="supportingDocumentInput"){
      if(size > this.maxSizeInBytes){
        console.log("file size:",size,this.maxSizeInBytes);
        Swal.fire("File Exceed!", `File size must be under 3MB`, "error");
        this.$refs[ref].value = ''; // Clear the file input
      }
    }
  },
  beforeRouteLeave(to, from, next) {
      console.log("><><><><> HEY",JSON.stringify(this.eloadRewardsForm),JSON.stringify(this.formExitChecker));
      if(JSON.stringify(this.eloadRewardsForm) != JSON.stringify(this.formExitChecker)){
        this.leaveform(next);
      }else{
        next();
      }
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    ELoad Send Reward
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <!-- Search and button -->
              <form class="px-4" @submit.prevent="handleSubmit()">
                <div class="row mb-2 px-3">
                  <div class="mb-3 col-md-12">
                    <label class="form-label small fw-bold">Event Name<span style="color: red">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="eloadRewardsForm.name"
                      placeholder="Type campaign Name"
                      :class="{
                          'is-invalid': submitted && $v.eloadRewardsForm.name.$error,
                      }"
                    />
                    <div v-if="submitted && $v.eloadRewardsForm.name.$error"
                      class="text-danger">
                      <span v-if="!$v.eloadRewardsForm.name.required">This value is required.</span>
                    </div>
                  </div><!--event name-->
                  <div class="mb-3 col-sm-6">
                    <label class="form-label">Event Date<span style="color: red">*</span></label>
                    <flat-pickr
                      v-model="eloadRewardsForm.event_date"
                      :config="config"
                      placeholder="Select event date & time"
                      name="eventdate"
                      class="form-control"
                      :class="{
                          'is-invalid': submitted && $v.eloadRewardsForm.event_date.$error,
                      }"
                    ></flat-pickr>
                    <div v-if="submitted && $v.eloadRewardsForm.event_date.$error"
                      class="text-danger">
                      <span v-if="!$v.eloadRewardsForm.event_date.required">This value is required.</span>
                    </div>
                  </div><!--event date-->
                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold">Type<span style="color: red">*</span></label>
                    <multiselect 
                      v-model="eloadRewardsForm.type" 
                      deselect-label="Can't remove this value" 
                      track-by="value" label="name" 
                      placeholder="Select type here..." 
                      :options="typeOptions" 
                      :searchable="false" 
                      :allow-empty="false"
                      :class="{
                          'is-invalid': submitted && $v.eloadRewardsForm.type.$error,
                      }">
                      <template slot="singleLabel" slot-scope="{ option }">
                        <span class="text-capitalize">{{ option.name }}</span>
                      </template>
                    </multiselect>
                    <div v-if="submitted && $v.eloadRewardsForm.type.$error"
                      class="text-danger">
                      <span v-if="!$v.eloadRewardsForm.type.required">This value is required.</span>
                    </div>
                  </div><!--event type-->
                  <div class="mb-3 col-sm-12">
                    <a :href="eloadRewardsForm.documentSignUrl" target="_blank" v-if="eloadRewardsForm.documentSignUrl != null" class="pull-right">
                      <i class="uil-file-alt"></i> Link here
                    </a> 
                    <label class="form-label">Supporting Document <span style="color: red">*</span></label>
                    <b-form-file
                      class="form-control"
                      type="file"
                      ref="supportingDocumentInput"
                      v-model="eloadRewardsForm.file"
                      @change="onFileChange"
                      plain
                    />
                    <label class="form-label pull-right fs-12 text-success custom__remove"  @click="openCreateModal">How to reduce size?</label>
                    <label class="form-label fs-12">File extension: CSV, xlsx, excel format limit size: 3mb</label>
                    <div v-if="submitted && $v.eloadRewardsForm.file.$error"
                      class="text-danger">
                      <span v-if="!$v.eloadRewardsForm.file.required">This value is required.</span>
                    </div>
                  </div><!--supporting document-->
                  <div class="col-md-12 mb-3">
                    <template>
                      <div>
                        <label class="form-label">Note</label>
                        <b-form-textarea
                          id="textarea"
                          v-model="eloadRewardsForm.note"
                          placeholder="Enter note here..."
                          rows="3"
                          max-rows="6"
                        ></b-form-textarea>
                      </div>
                    </template>
                  </div><!--Event Note-->
                  
                  <div class="col-sm-12">
                    <label class="form-label">Upload your list of winner (Mass Upload)</label>
                    <div class="row">
                      <div class="col-sm-10">
                        <b-form-file
                          v-model="massUploadFile"
                          @change="onMassUploadFileChange"
                          class="form-control"
                          type="file"
                          ref="massWinnerInput"
                          plain
                        />
                      </div>
                      <div class="col-sm-2">
                        <button type="button" class="btn btn-secondary" style="width: 100%" @click="processMassUploadFile" :disabled="!massUploadFile">Upload File</button>
                      </div>
                    </div>
                    <div class="col-sm-10">
                      <label class="form-label pull-right fs-12 text-primary"><a href="/assets/files/eload-reward-mass-upload-template.xlsx" download>Download Blank Template</a></label>
                      <label class="form-label fs-12">File extension: CSV, xlsx, excel format limit size: 3mb</label>
                    </div>
                    <div class="col-sm-2"></div>
                  </div><!--supporting document-->
                    
                  <div class="col-md-12">
                    <span class="pull-right mt-4" v-if="false">Total Winner: {{ eloadRewardsForm.receiver.length }}<br>Total Amount: {{ TotalWinnerAmount | toCurrency}}</span>
                    <b-button variant="primary" class="w-sm mt-4" type="button" @click="openAddWinnerModal">Add Winner</b-button> 
                    <div v-if="submitted && $v.eloadRewardsForm.receiver.$error"
                      class="text-danger">
                      <span v-if="!$v.eloadRewardsForm.receiver.required">This value is required.</span>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <!-- table responsive -->
                    <div class="table-responsive">
                      <div class="table align-middle table-nowrap">
                        <!-- eloadRewardsForm.receiver -->
                        <b-table
                          :items="displayWinnerTbl"
                          :fields="addWinnerTblFields"
                          responsive="sm"
                        >
                          <template #cell(business)="data">
                            <span>{{(data.item.business == null ? "-":data.item.business) | truncator(20,'...')}}</span>
                          </template>
                          <template #cell(name)="data">
                            <span>{{!isEmpty(data.item.name)?data.item.name:(!isEmpty(data.item.cognito_sub)?data.item.cognito_sub:'-') | truncator(20,'...')}}</span>
                          </template>
                          <template #cell(email_address)="data">
                            <span>{{(data.item.email == null ? "-":data.item.email)}}</span>
                          </template>
                          <template #cell(mobile_number)="data">
                            <span>{{data.item.mobile_number}}</span>
                          </template>
                          <template #cell(action)="data">
                            <div class="d-flex">
                              <div class="btn-group me-2 mb-2 mb-sm-0">
                                <span class="text-primary c-pointer" @click="removeWinner(data.item)">
                                  Remove
                                </span>
                              </div>
                            </div>
                          </template>
                          <template #cell(amount)="data">
                            <b-form-input
                              @keypress="isNumber($event)"
                              @blur="recompute"
                              type="number"
                              step="0.01"
                              class="form-control"
                              v-model="data.item.amount"
                              placeholder="0.00"
                              oninput="javascript: if (this.value > 3000) this.value = 3000;"
                              style="width:fit-content"
                            />
                          </template>
                        </b-table>
                      </div>
                    </div>
                    <div class="row g-0 text-center" v-if="eloadRewardsForm.receiver.length == 0">
                      <span>No data to display.</span>
                    </div>
                    <div class="row g-0 text-center text-sm-start">
                      <!-- end col -->
                      <div class="col-sm-12"  v-if="eloadRewardsForm.receiver.length != 0 && eloadRewardsForm.receiver.length > 10">
                        <div class="row">
                          <div class="col">
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <!-- pagination -->
                              <b-pagination  v-if="eloadRewardsForm.receiver.length != 0 && eloadRewardsForm.receiver.length > 10"
                                class="pagination-rounded"
                                v-model="displayWinnerPagination.page"
                                :total-rows="eloadRewardsForm.receiver.length"
                                :per-page="displayWinnerPagination.rows"
                                @input="winnerTblPaginator"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end col -->
                    </div>
                  </div><!--end of col-12-->
                </div>
                <div class="row mt-3 mb-2 px-3">
                  <div class="col-md-6 mt-3 p-0">
                    <b-button variant="link" class="w-sm" type="submit" @click="eloadRewardsForm.saveType = 'dr'">SAVE AS DRAFT</b-button>
                  </div>
                  <div class="col-md-6 mt-3 ta-right p-0">
                    <b-button variant="primary" class="w-sm" type="submit" @click="eloadRewardsForm.saveType = 'am'">Save</b-button>
                    <router-link :to="{ name: 'Eload Rewards', params: {} }" class="tc-white">
                      <b-button variant="light" class="w-sm ml-2" type="button" >Cancel</b-button>
                    </router-link>
                  </div>
                </div>
              </form>
            </div>
            <!-- end col -->
            <!-- end row -->
            
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
    <!-- create modal -->
    <b-modal
      id="reduceSizeInfo"
      title="How to reduce size?"
      size="md"
      centered
      hide-footer
      v-model="createModal"
    >
      <div class="row">
        <div class="col-md-12 mb-3">
          <h5>How to reduce photo file size on a Windows PC:</h5>
          <p>If you’re working with a Windows PC and would like to know how to make a photo smaller, you can follow these steps:</p>
          <ol>
            <li class="mb-2">Once you’ve located the image you wish to compress, open the photo in ‘Photos.’ Select the ‘…’ option on the top right-hand side of the Photo’s Window. A drop-down menu will appear.</li>
            <li class="mb-2">Select ‘Resize’ to enable a pop-up menu. Select a size. The options are: S (small) or M (medium). Once you click on a size, a ‘Save As’ window will open.</li>
            <li class="mb-2">Name your photo in the ‘File Name’ field. Select a file location by clicking on a location in the left-hand sidebar. Select ‘Save’ at the bottom right-hand corner of the window. The compressed file will be saved to this location.</li>
          </ol>  <hr>
          <h5>How to reduce a photo file size on a Mac:</h5>
          <p>If you’re working with a Mac and would like to learn how to reduce the size of a photo, you can follow these steps:</p>
          <ol>
            <li class="mb-2">Select the image you wish to compress. Select ‘File’ in the upper left-hand corner of the screen. A drop-down menu will appear. Select the ‘Open With’ option, which will prompt a pop-out menu. Select ‘Preview.’</li>
            <li class="mb-2">Your selected image will then appear in ‘Preview’ mode. Select ‘File’ in the upper left-hand side of your screen. A drop-down menu will appear. Select ‘Export.’ A new window will appear.</li>
            <li class="mb-2">Name your photo in the field at the top of the window. Save to a location by selecting ‘Where’ on the drop-down menu (to your Desktop, for example).</li>
            <li class="mb-2">If necessary, change the image to a JPEG format by selecting this option in the box on the right of the ‘Format’ heading. Then, adjust the compression quality by clicking and dragging the slider to the left. Select ‘Save’ at the bottom right-hand side to save to the selected folder.</li>
          </ol>  
        </div>
      </div>


    </b-modal>
    <!-- end create modal -->
    <!-- add winner modal -->
    <b-modal
      id="addWinner"
      title="Add Winner"
      size="lg"
      centered
      hide-footer
      v-model="addWinner"
    >
      <div class="row">
          <div class="col-md-12">
            <label class="form-label small fw-bold">Search: {{userListTotalRows > 0? userListTotalRows+" Record(s)":""}}</label>
            <b-form-group description="Search Keyword" class=" ta-right">
              <form class="d-flex" @submit.prevent="getUserList()">
                <b-form-group id="input-group-3" label-for="input-3">
                  <b-form-select
                    class="form-select rounded-0 rounded-start shadow-none"
                    style="width: fit-content"
                    id="input-3"
                    v-model="searchValue.searchField"
                    :options="searchList"
                  ></b-form-select>
                </b-form-group>

                <b-input-group>
                  <b-form-input
                    class="rounded-0"
                    v-model="searchValue.search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      variant="primary"
                      type="submit"
                      class="rounded-0 rounded-end px-2"
                    >
                      <i class="bx bx-search bx-fw"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </form>
            </b-form-group>
          </div><!--search form-->
          <b-col sm="12" class="mb-3">
            <label class="form-label small fw-bold">Amount<span style="color: red">*</span></label>
            <div class="input-group">
              <b-form-input
                @keypress="isNumber($event)"
                type="number"
                step="0.01"
                class="form-control"
                v-model="addWinnerAmount"
                placeholder="0.00"
                oninput="javascript: if (this.value > 3000) this.value = 3000;"
              />
            </div>
            <div>
              <label class="form-label fs-12">This value should be lower than or equal to 3,000.</label>
            </div>
          </b-col><!--recipient amount-->
          <div class="col-sm-12">
            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="userList"
                  :fields="tblFields"
                  responsive="sm"
                >
                  <template #cell(business)="data">
                    <span>{{(data.item.business == null ? "-":data.item.business) | truncator(20,'...')}}</span>
                  </template>
                  <template #cell(name)="data">
                    <span>{{!isEmpty(data.item.name)?data.item.name:(!isEmpty(data.item.cognito_sub)?data.item.cognito_sub:'-') | truncator(20,'...')}}</span>
                  </template>
                  <template #cell(email_address)="data">
                    <span>{{(data.item.email == null ? "-":data.item.email)}}</span>
                  </template>
                  <template #cell(mobile_number)="data">
                    <span>{{data.item.mobile_number}}</span>
                  </template>
                  <template #cell(action)="data">
                    <div class="d-flex">
                      <div class="btn-group me-2 mb-2 mb-sm-0">
                        <span class="text-primary c-pointer" v-if="data.item.cognito_sub != null && !isAddedInWinner(data.item.id)" @click="newWinner(data.item)">
                          Add
                        </span>
                        <span class="text-primary c-pointer" v-else-if="data.item.cognito_sub != null && isAddedInWinner(data.item.id)" @click="removeWinner(data.item)">
                          Remove
                        </span>
                        <span v-else>
                          (No Wallet ID)
                        </span>
                      </div>
                    </div>
                  </template>
                  <template #cell(account_freeze)="data">
                    <span :class="getStatusClassColor(data.item.account_freeze)">{{data.item.account_freeze == null || data.item.account_freeze == 0 ? "Enabled":"Freezed"}}</span>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row g-0 text-center" v-if="userListTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start">
              <!-- end col -->
              <div class="col-sm-12"  v-if="userListTotalRows != 0 && userListTotalRows > 10">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="searchValue.rows"
                            :options="pageOptions"
                            @change="onDisplayChange('modal')"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <!-- pagination -->
                      <b-pagination  v-if="userListTotalRows != 0 && userListTotalRows > 6 && userListTotalRows > searchValue.rows"
                        class="pagination-rounded"
                        v-model="searchValue.page"
                        @input="getUserList"
                        :total-rows="userListTotalRows"
                        :per-page="searchValue.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div><!--end of col-12-->
      </div><!--end of row-->
    </b-modal>
    <!-- end winner modal -->

  </div>
</template>
<style>
.custom-checkbox-method label {margin-left: 10px;}
.custom-checkbox-method input {margin-left: 15px;}
.required-input {color:red;}
.calendar-icon {display: block;font-size: 20px;padding: 8px;background-color: grey;}
.custom__tag{
    padding: 1px 5px;
    background: #E73092;
    color: #FFF;
    border-radius: 10px;
    margin-right: 5px;
}
.custom__remove, .c-pointer{
  cursor: pointer;
}
.fs-12{
  font-size: 12px;
}
.ml-2{
  margin-left: 10px;
}

.fs-13 {
  font-size: 13px;
}

.duplicate-container {
  font-size: 13px;
  border: solid 1px #AFAFAF;
  max-height: 300px;
  overflow-y: scroll;
}
</style>